import { useEffect, useState } from "react";
import { UserGroupIcon } from "@heroicons/react/24/outline";
import { useLocale } from "../i18n";
import type { RecordValue } from "./types";
import "../styles/team-symbol.css";

export function TeamLogo({ team }: { team: RecordValue }) {
  const { w } = useLocale();
  const media = team.logoMedia as RecordValue | undefined;
  const url = typeof media?.previewUrl === "string" && /^https?:\/\//.test(media.previewUrl) ? media.previewUrl : undefined;
  const [failedUrl, setFailedUrl] = useState<string>();
  useEffect(() => { setFailedUrl(undefined); }, [url]);
  return <span className="event-team-symbol">{url && failedUrl !== url
    ? <img key={url} src={url} alt={`${w("شعار الفريق", "Team logo")} · ${team.name || team.displayName}`} onError={() => setFailedUrl(url)} loading="lazy" referrerPolicy="no-referrer" />
    : <UserGroupIcon aria-hidden="true" />}</span>;
}
